// Module
var code = `<div class="js-types-manager-screen">
    <div class="js-left-panel">
        <instrumentsDefaultsLookup name="lookup" allSettings="{{.allSettings}}" itemSettings="{{.itemSettings}}" />
    </div>
    <div class="js-right-panel">
        <div class="js-scrollable-container">
            <div class="js-mini-container">
                <terceraLabel text="{{.slDefaultText}}" />
                <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.VisibleSLDefaultOffsetTicksDecimal}}" step="{{.sltpStep}}" minValue="{{.sltpMinValue}}" decimalPrecision="{{.sltpDecimalPrecision}}" />
            </div>
            <div class="js-mini-container">
                <terceraLabel text="{{.tpDefaultText}}" />
                <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.VisibleTPDefaultOffsetTicksDecimal}}" step="{{.sltpStep}}" minValue="{{.sltpMinValue}}" decimalPrecision="{{.sltpDecimalPrecision}}" />
            </div>
            {{#if .isAllowSLTPPercent}}
                <div class="js-mini-container">
                    <terceraLabel text="{{.slDefaultPercentText}}" />
                    <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.SLDefaultOffsetPrecent}}" step="0.01" minValue="0.01" decimalPrecision="2" />
                </div>
                <div class="js-mini-container">
                    <terceraLabel text="{{.tpDefaultPercentText}}" />
                    <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.TPDefaultOffsetPrecent}}" step="0.01" minValue="0.01" decimalPrecision="2" />
                </div>
            {{/if}}
            <div class="js-mini-container">
                <terceraLabel text="{{.usrQtyText}}" />
                <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.UserQuantityCoef}}" />
            </div>
            <div class="js-mini-container">
                <terceraLabel text="{{.priceIncrementText}}" />
                <terceraNumeric enabled="{{!.itemSettings.readOnly}}" value="{{.itemSettings.PriceIncrementTicks}}" />
            </div>
            <div class="js-mini-container">
                <terceraLabel text="{{.defLotsSetupText}}" />
                <div class="js-lots-setup-table">
                    <quickTableRactive name="quickTableRactive" isAttached="{{@this.isAttached()}}" />
                </div>
            </div>

            <!-- SLTPtriggers #109798 -->
            <!-- <div class="js-mini-container"> -->
            <sltpTriggerControl name="SellTP" isForSL="false" side="1" itemSettings="{{.itemSettings}}" triggersVisible="{{triggersVisible}}" />
            <!-- </div>    -->
            <!-- <div class="js-mini-container"> -->
            <sltpTriggerControl name="SellSL" isForSL="true" side="1" itemSettings="{{.itemSettings}}" triggersVisible="{{triggersVisible}}" />
            <!-- </div>    -->
            <!-- <div class="js-mini-container"> -->
            <sltpTriggerControl name="BuyTP" isForSL="false" side="0" itemSettings="{{.itemSettings}}" triggersVisible="{{triggersVisible}}" />
            <!-- </div>    -->
            <!-- <div class="js-mini-container"> -->
            <sltpTriggerControl name="BuySL" isForSL="true" side="0" itemSettings="{{.itemSettings}}" triggersVisible="{{triggersVisible}}" />
            <!-- </div>    -->
            <!-- SLTPtriggers #109798 -->
        </div>
    </div>
</div>`;
// Exports
export default code;